import { render } from "./AddStatutCommandeModal.vue?vue&type=template&id=41195ef0&ts=true"
import script from "./AddStatutCommandeModal.vue?vue&type=script&lang=ts"
export * from "./AddStatutCommandeModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__